module.exports = {
	submitUberCode: function(code) {

		return fetch('https://us-central1-cupper-d6095.cloudfunctions.net/codeExchange?code='+code, {
			  method: 'POST'
			})
			.then((response) => {
				return response.status
			})
		    .catch((error) => {
		        console.error(error);
		    });
	}
}


// WEBPACK FOOTER //
// ./src/api.js